<template>
  <div class="container" style="background-color: #fff;">
    <HeaderComponent :menu-id="2"></HeaderComponent>
    <div>
      <div class="mianze-top-container">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>古钱币送评</span>免责条款</div>
        </div>
      </div>
      <div style="background-color: #FFFAF4;">
        <div class="tiaokuan-box">
          <div class="tixing"><span>特别提醒:</span> 您一经选择水石评级的服务，即视为接受本承诺全部条款，若您不接受本承诺全部或部分条款，请及时向我们作出说明。</div>
          <p class="p-ty" style="margin: 50px 0;">1.委托方确认所提交鉴定的古钱币(含已知瑕疵币)因存世年代久远、材质物理稳定性不足、铸造工艺技术局限或先天缺损等固有属性，即便鉴定机构道循专业操作规范及合理注意义务实施鉴定，仍可能发生漆面剥离、表面附着物脱落、既有瑕疵扩延等不可完全规避的情形，委托方自愿提交鉴定申请，并独立承担该类固有风险。</p>
          <p class="p-ty">2.鉴定机构在无故意侵权或重大过失前提下，对下列情形所致古钱币毁损，依法不承担损害赔偿责任:</p>
          <ul>
            <li>(1)鉴定操作过程中，因钱币自身固有瑕疵(如结构性裂纹、材质脆化、氧化锈蚀)引发的破损;</li>
            <li>(2)原有隐性瑕疵在鉴定流程中显性化或程度加剧;</li>
            <li>(3)委托方未预先书面披露的特殊材质属性、隐秘修复痕迹导致的变化或毁损;</li>
            <li>(4)封装币(盒子币)开盒鉴定环节产生的合理损耗(委托方提交封装币鉴定即视为对本条款的明示同意)。</li>
          </ul>
          <p class="p-ty" style="margin: 50px 0;">3.邮寄送评:寄件保价费用由送评方自行承担，保价丢失按快递公司保价协议理赔。</p>
          <p class="p-ty" style="margin: 50px 0;">4.收到缴费通知后10个工作日内付清服务费;逾期未缴费藏品水石代为保管3个月;超过3个月经3次催告仍未付费，视为送评人放弃藏品所有权，水石有权处置藏品抵扣欠费，余款留存公司。</p>
        </div>
      </div>
        
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.mianze-top-container{
  padding-bottom: 80px;
  width: 100%;
  background-image: url('@/assets/image/border-bj-3.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: bottom;
}
</style>